export default __webpack_public_path__ + "static/media/deltalight.a6e3e8e7.png";